// src/pages/TestEmail.jsx
import axios from 'axios';
import React, { useState } from 'react';

const testAxios = axios.create({
    baseURL: 'https://mailing.confessionsofanutritionfreak.co.ke',
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: false  // Add this
});

const TestEmail = () => {
    const handleSendTestEmail = async () => {
        const emailData = {
            email: 'mjoel4708@gmail.com',
            subject: 'Updated Blog Post: Managing Stress Eating: Strategies for a Healthier Lifestyle',
            message: 'test'
        };
        try {
            const response = await testAxios.post('/', emailData);
            console.log('Test email response:', response.data);
            alert('Test email sent successfully!');
        } catch (error) {
            console.error('Error details:', {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status
            });
            alert(`Error sending test email: ${error.response?.data?.error || error.message}`);
        }
    };

    return (
        <div className="max-w-4xl mx-auto p-6 space-y-6">
            <button onClick={handleSendTestEmail}>Send Test Email</button>
        </div>
    );
};

export default TestEmail;